var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:({ fontSize: _vm.fontSize, lineHeight: _vm.lineHeight, color: _vm.color, fontWeight: _vm.weight, fontStyle: _vm.fontStyle}),domProps:{"innerHTML":_vm._s(_vm.hyperText)}})}
var staticRenderFns = []

export { render, staticRenderFns }